import { useState } from 'react';
import { useDarkMode } from '@/hooks/useDarkMode';

import { ChevronDown } from 'lucide-react';
export default function SortDropdown({ sortBy, onChange }) {
  const [showSortMenu, setShowSortMenu] = useState(false);
  const darkMode = useDarkMode();

  const sortOptions = [
    { value: '', label: 'Featured' },
    { value: 'name-az', label: '🔤 Name: A–Z' },
    { value: 'price-low', label: '💰 Price: Low to High' },
    { value: 'price-high', label: '💎 Price: High to Low' }
  ];

  const currentSort = sortOptions.find(opt => opt.value === sortBy) || sortOptions[0];

  return (
    <div className="relative">
      <button
        onClick={() => setShowSortMenu(!showSortMenu)}
        className="px-4 py-2 rounded-lg transition-all hover:scale-105 flex items-center gap-2"
        style={{
          background: darkMode.isDark ? 'rgba(255, 255, 255, 0.6)' : 'white',
          border: `2px solid ${darkMode.isDark ? '#D4A080' : '#E5E5E5'}`,
          color: '#20212B'
        }}
      >
        <span className="text-sm font-medium">
          {currentSort.label}
        </span>
        <ChevronDown className="w-4 h-4" />
      </button>

      {showSortMenu && (
        <div
          className="absolute right-0 mt-2 w-56 rounded-lg overflow-hidden z-50 transition-colors"
          style={{
            background: darkMode.isDark ? '#FED7A5' : 'white',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            border: darkMode.isDark ? '1px solid #E8C795' : 'none'
          }}
        >
          {sortOptions.map(option => (
            <button
              key={option.value}
              onClick={() => {
                onChange(option.value);
                setShowSortMenu(false);
              }}
              className="w-full px-4 py-3 text-left text-sm transition-colors"
              style={{
                color: sortBy === option.value ? '#9E6752' : '#20212B',
                fontWeight: sortBy === option.value ? '600' : '400',
                background: sortBy === option.value ? (darkMode.isDark ? 'rgba(254, 215, 165, 0.3)' : 'rgba(254, 215, 165, 0.2)') : 'transparent'
              }}
              onMouseEnter={(e) => {
                if (sortBy !== option.value) {
                  e.currentTarget.style.background = darkMode.isDark ? 'rgba(232, 199, 149, 0.5)' : 'rgba(0,0,0,0.03)';
                }
              }}
              onMouseLeave={(e) => {
                if (sortBy !== option.value) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
